export default function SwitchLabel({ children, htmlFor }) {
    return (
        <span htmlFor={htmlFor} className="block text-sm/6 text-zinc-500">
            {children}
        </span>
    );
};
